import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Clock } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-charcoal text-white relative overflow-hidden" data-id="element-186">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-accent via-sage to-accent" data-id="element-187"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-188">
        <FadeIn data-id="element-189">
          <h2 className="text-2xl sm:text-4xl font-bold mb-3 sm:mb-6" data-id="element-190">
            No vas a pagar{' '}
            <span className="line-through text-white/50 decoration-accent decoration-4" data-id="element-191">
              $14.99
            </span>
            .
          </h2>
          <p className="text-base sm:text-xl text-cream/80 mb-6 sm:mb-10 font-serif italic" data-id="element-192">
            Ni siquiera la mitad de eso. Queremos que esta solución llegue a
            cada mujer que la necesita.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-193">
          <div className="bg-white text-charcoal rounded-2xl sm:rounded-3xl p-6 sm:p-12 shadow-2xl sm:transform sm:scale-105 relative" data-id="element-194">
            <div className="absolute -top-4 sm:-top-5 left-1/2 -translate-x-1/2 bg-accent text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full font-bold text-xs sm:text-sm uppercase tracking-wider shadow-lg flex items-center gap-1.5 sm:gap-2 whitespace-nowrap" data-id="element-195">
              <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-196" />
              Oferta por tiempo limitado
            </div>

            <p className="text-sm sm:text-lg font-bold text-charcoal-light uppercase tracking-widest mb-1 sm:mb-2 mt-3 sm:mt-4" data-id="element-197">
              Accede hoy por solo
            </p>
            <div className="flex items-start justify-center gap-1 mb-4 sm:mb-8" data-id="element-198">
              <span className="text-2xl sm:text-4xl font-bold text-sage-dark mt-1 sm:mt-2" data-id="element-199">
                $
              </span>
              <span className="text-6xl sm:text-8xl font-bold text-sage-dark leading-none tracking-tighter" data-id="element-200">
                6
              </span>
              <span className="text-2xl sm:text-4xl font-bold text-sage-dark mt-1 sm:mt-2" data-id="element-201">
                .39
              </span>
            </div>

            <div className="bg-cream p-3 sm:p-4 rounded-xl mb-4 sm:mb-8 border border-accent/20" data-id="element-202">
              <p className="text-xs sm:text-sm text-charcoal font-medium" data-id="element-203">
                <strong className="text-accent" data-id="element-204">Atención:</strong> Precio válido
                solo mientras el cronómetro esté en pantalla. Una vez termine,
                volverá a su precio original de $14.99.
              </p>
            </div>

            <CTAButton className="w-full text-sm sm:text-lg py-4 sm:py-5" data-id="element-205" />

            <div className="mt-4 sm:mt-6 flex items-center justify-center gap-2 text-xs sm:text-sm text-charcoal-light font-medium" data-id="element-206">
              <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-sage" data-id="element-207" />
              <span data-id="element-208">Pago 100% Seguro y Encriptado</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}